// Утилита для форматирования текста фильтров
export const formatFilterText = (text) => {
  if (!text || typeof text !== 'string') {
    return text;
  }

  const lowerText = text.toLowerCase().trim();

  // Преобразования для множественного числа
  if (lowerText === 'пост') {
    return 'посты';
  }

  if (lowerText === 'статья') {
    return 'статьи';
  }

  // Возвращаем оригинальный текст, если преобразование не нужно
  return text;
};

/** Единственное число для подписи фильтра на карточке публикации */
export const formatCardFilterText = (text) => {
  if (text == null) return text;

  if (Array.isArray(text)) {
    return text.map((item) => formatCardFilterText(item)).join(', ');
  }

  if (typeof text !== 'string') {
    return String(text);
  }

  const lowerText = text.toLowerCase().trim();

  if (lowerText === 'статьи') {
    return 'статья';
  }

  if (lowerText === 'посты') {
    return 'пост';
  }

  return text;
};

export default formatFilterText;
